import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService } from '@spartacus/core';
//import * as html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { MakeAPaymentService } from 'src/app/make-a-payment/make-a-payment.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { OpenStatementsService } from '../open-statements.service';

@Component({
  selector: 'app-statement-display',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './statement-display.component.html',
  styleUrls: ['./statement-display.component.scss'],
  host: {
    '[style.overflow]': '"hidden"',
    '[style.width]': '"100%"',
  },
})
export class StatementDisplayComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: ElementRef;
  @ViewChild('scrollableContent') scrollBody: ElementRef;
  @Input() toShow: boolean;
  @Input() statement: any;
  someInputField: any;
  allStatementData: any;
  accountNumber = null;
  loadSub: Subscription;
  userAccSubs: Subscription;
  allStatementsSub: Subscription;
  showPopUp: boolean;
  isPDF = false;
  baseSiteId: string;
  isAsmUser: boolean = false;
  firewallExempt: boolean = false;
  isComServeAgent: boolean = false;
  csAgentAuthSubscription: Subscription;
  constructor(
    private readonly stService: OpenStatementsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly makeAPayment: MakeAPaymentService,
    private readonly sharedService: SharedService,
    public activeModal?: NgbActiveModal,
    private baseSite?: BaseSiteService,
    private readonly csAgentAuthService?: CsAgentAuthService,
    private readonly pfService?: CustomProfileAndPreferencesService,
  ) { }

  ngOnInit(): void {
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    // this.firewallExempt = this.sharedService.getSessionStorage('firewallExempt');
    this.baseSite.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.showPopUp = false;
    this.allStatementData = [];
    this.cdr.detectChanges();
    this.stService.getAccountId();
    // this.userAccSubs = this.stService.userAccountIdDetails.subscribe((res) => {
    this.pfService._userAccountData.subscribe((res) => {
      if (this.accountNumber == null) {
        this.accountNumber = res.defaultB2BUnit.uid;
        this.getAllStatements();
      }
    });

    this.loadSub = this.stService.loadStatements.subscribe((res) => {
      if (!!res !== false) {
        this.getAllStatements();
      }
    });
  }

  // async makePdf(){

  //   const div: HTMLElement = this.content.nativeElement;
  //   const scrollHeight:HTMLElement = this.scrollBody.nativeElement;
  //   const width = div.offsetWidth;
  //   // const height = scrollHeight.scrollHeight;
  //   const height  = div.offsetHeight;
  //   const ratio = height/width;
  //   await html2canvas.default(div, {
  //     backgroundColor: 'white',
  //     scale: 1,
  //   }).then(canvas => {
  //   const contentDataURL = canvas.toDataURL('image/png');
  //   const doc = new jsPDF('p','px','a4');
  //   // doc.internal.pageSize.width = width;
  //   // doc.internal.pageSize.height = height;
  //   const wi = doc.internal.pageSize.getWidth();
  //   let height = doc.internal.pageSize.getHeight();
  //   height = ratio * width; 
  //   // const imgWidth = 1000; // your own stuff to calc the format you want
  //   // const imgHeight = canvas.height * imgWidth / canvas.width; // your own stuff to calc the format you want 

  //   doc.addImage(contentDataURL, 'PNG', 0 , 0, width , ratio * width);
  //   doc.save('statement.pdf'); // save / download
  //   })
  // }


  checkNegativeValue(data, checkNegative = false) {
    return checkNegative ? Number(data) < 0 : data?.transType === 'Credit Memo';
  }

  generateSavePdf() {
    this.isPDF = true;
    this.activeModal.close();

    // old approach 


    // const options = {
    //   margin: [20,5],
    //   filename: 'pdfFileName.pdf',
    //   image:        { type: 'jpeg', quality: 0.98 },
    //   html2canvas:  { scale: 1, letterRendering: true },
    //   jsPDF:        { unit: 'pt', format: 'letter', orientation: 'portrait' },
    //   pagebreak:    { mode: 'css', avoid: ['.payment-constraints__1','.payment-constraints__2 > label','.payment-constraints__2 > ul','.remittance-wrapper','.remittance','.remittance_address > label','.remittance_address > ul',]
    //   } 
    // };

    // const element: Element = document.getElementById('productList-areax');
    // html2pdf().from(element).set(options).save();
    // this.stService.reloadComponent.next(true);


    // working solution but styles arent reflecting

    const element = (document.getElementsByClassName('acc-order-details')[0]) as HTMLElement;
    let doc = new jsPDF('p', 'pt', 'letter');
    doc.html(element, {
      callback: function (jsPdf) {
        jsPdf.save("Statement.pdf");
        this.stService.reloadComponent.next(true);
      },
      margin: [20, 20, 20, 20], // Set appropriate margins
      autoPaging: 'text', // Crucial for handling text flow across pages
      html2canvas: {
        allowTaint: true,
        letterRendering: true,
        logging: false,
        scale: 0.5, // Adjust the scale to fit content
      },

    });

    // new approach

    // const element  = document.getElementsByClassName('acc-order-details')[0].getElementsByTagName('div');
    // const table = (document.getElementsByTagName('table')[0]) as HTMLTableElement;
    // const pdf =  new jsPDF('p', 'pt', 'letter');
    // pdf.html(element[0],{
    //   x: 30,
    //   y: 50,
    //   html2canvas: {scale: 1},
    //   windowWidth: pdf.internal.pageSize.width, 
    //   width: pdf.internal.pageSize.width
    // }).then(() => pdf.save('stmnt.pdf'));
    // autoTable(pdf,{ html: table, useCss: true, showHead: 'firstPage', tableWidth: 'auto', 
    // startY: 250,margin: 30, theme:'plain',willDrawCell : (data) => {
    //   if(data.row.section == 'foot'){
    //     pdf.text('BOTTOM TEXT',10, (pdf as any).lastAutoTable.finalY + 20);
    //   }
    // }});
    // setTimeout(() => {
    //   pdf.html(element[7],{
    //     x: 0,
    //     y: (pdf as any).lastAutoTable.finalY + 20,
    //     html2canvas: {scale: 1},
    //     windowWidth: pdf.internal.pageSize.width, 
    //     width: pdf.internal.pageSize.width 
    //   }).save('statement.pdf');
    // }, 1000);


    // this.stService.reloadComponent.next(true);

  }

  generateInvoicePDF(invoiceNo) {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  onPrint() {
    window.print(); // only modal content should get print
  }

  getAllStatements() {
    this.allStatementsSub = this.stService
      .getAllStatements({
        accountId: this.accountNumber,
        endDate: this.statement.toDte,
        fields: 'DEFAULT',
      })
      .subscribe((res) => {
        if (res) {
          if (res?.isComServeAgent) {
            this.isComServeAgent = res.isComServeAgent;
          }
          this.allStatementData = JSON.parse(JSON.stringify(res));
          this.showPopUp = true;
          this.cdr.detectChanges();
          if (this.toShow === false) {
            this.generateSavePdf();
          }
        }
      });
  }

  ngOnDestroy() {
    this.showPopUp = false;
    this.loadSub?.unsubscribe();
    this.userAccSubs?.unsubscribe();
    this.allStatementsSub?.unsubscribe();
  }
  getScheduledPaymentDate(date) {
    const x = new Date(date);
    x.setDate(x.getDate() - 3);
    return x.toLocaleDateString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
  calcTotalDiscounts(statements, column) {
    let total = 0;
    statements.forEach(entry => {
      total += column == 'discount' ? parseFloat(entry.discount) :
        (entry.transType.toLowerCase() == 'credit memo' ? (0 - entry.amountDue) : entry.amountDue);
    });
    return total;
  }
  asmStringCheck(invoiceNumber) {
    // this.isAsmUser = true;
    // this.firewallExempt = true;
    // this.isComServeAgent = true; // if false(firewall exempt), then show as link , if true(normal asm), show as text
    let val = (/^\d+$/).test(invoiceNumber);
    return (!val || invoiceNumber?.length >= 11 || invoiceNumber?.length <= 7 ||
      (!invoiceNumber?.startsWith('47') && !invoiceNumber?.startsWith('84')) || 
      (this.isAsmUser && this.isComServeAgent));
  }
}